export const mixinPlatCurrencySymbol = {
  computed: {
    // 平台货币符号
    platCurrencySymbol() {
      return this.$store.getters.currencySymbols

      //   瓦太欧洲站：€；瓦太美国站：$；其它：¥；
      /*if (this.$store.getters.ISGJTEU) {
                    return '€'
                  } else if (this.$store.getters.ISGJTEUS) {
                    return '$'
                  } else {
                    return '¥'
                  }*/
    }
  }
}



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/mixin/currencySymbol.js